/**
 * OAuth Callback Handler
 */

import { handleCallback } from '../lib/keycloak.js';

export async function renderCallback() {
  const app = document.getElementById('app');
  app.innerHTML = '';

  const main = document.createElement('main');
  main.className = 'callback-container';
  main.innerHTML = `
    <div class="callback-box">
      <div class="spinner" style="width: 48px; height: 48px;"></div>
      <p style="margin-top: var(--spacing-md); color: var(--color-cloud-grey);">
        Completing sign in...
      </p>
    </div>
  `;

  app.appendChild(main);

  try {
    // Handle the OAuth callback
    const { user } = await handleCallback();

    // Redirect to dashboard
    window.location.href = '/dashboard';
  } catch (error) {
    console.error('Login failed:', error);

    main.innerHTML = `
      <div class="callback-box">
        <div style="font-size: 48px; margin-bottom: var(--spacing-md);">❌</div>
        <h2 style="color: var(--color-error); margin-bottom: var(--spacing-sm);">Login Failed</h2>
        <p style="color: var(--color-cloud-grey); margin-bottom: var(--spacing-md);">
          ${error.message}
        </p>
        <a href="/login" class="btn btn-primary" data-link>Try Again</a>
      </div>
    `;
  }
}

// Add styles
const style = document.createElement('style');
style.textContent = `
  .callback-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, var(--color-midnight-black) 0%, var(--color-storm-grey) 100%);
  }
  
  .callback-box {
    text-align: center;
    padding: var(--spacing-2xl);
  }
`;

if (!document.getElementById('callback-styles')) {
  style.id = 'callback-styles';
  document.head.appendChild(style);
}
